import React, { useState, useEffect } from 'react';
import { useApp } from '../App';
import BackButton from '../components/BackButton';
import api from '../api';
import { useI18n } from '../i18n/index.jsx';

const DOC_TYPES = [
  { value: 'oswiadczenie', label: '📋 Oświadczenie (BY/GE/MD/AM)', desc: 'Oświadczenie o powierzeniu pracy — до 24 мес' },
  { value: 'powiadomienie_ua', label: '🇺🇦 Powiadomienie (Ukraina)', desc: 'Powiadomienie — бесплатно' },
  { value: 'zezwolenie_a', label: '📄 Zezwolenie typ A', desc: 'Разрешение на работу — другие страны' },
  { value: 'zus_zua', label: '🏛️ ZUS ZUA', desc: 'Регистрация в ZUS — 7 дней от начала' },
  { value: 'zus_a1', label: '✈️ ZUS A1', desc: 'Делегирование — до 24 мес' },
];

const CONTRACT_TYPES = [
  { value: 'umowa_o_prace', label: 'Umowa o pracę' },
  { value: 'zlecenie', label: 'Umowa zlecenie' },
  { value: 'dzielo', label: 'Umowa o dzieło' },
];


export default function WorkPermits() {
  const { user, setPage } = useApp();
  const { t } = useI18n();
  const STATUS_LABELS = {
  draft: { label: t('applications.status_draft'), color: '#666', icon: '✏️' },
  submitted: { label: 'На рассмотрении', color: '#f59e0b', icon: '⏳' },
  approved: { label: 'Утверждено', color: '#10b981', icon: '✅' },
  filing: { label: 'Подаётся...', color: '#3b82f6', icon: '🔄' },
  filed: { label: 'Подано', color: '#6366f1', icon: '📨' },
  registered: { label: 'Зарегистрировано', color: '#059669', icon: '🎉' },
  rejected: { label: t('invoices_in.status_rejected'), color: '#ef4444', icon: '❌' },
  error: { label: 'Ошибка', color: '#ef4444', icon: '⚠️' },
};
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({
    document_type: 'oswiadczenie',
    employee_first_name: '', employee_last_name: '',
    employee_citizenship: '', employee_date_of_birth: '',
    employee_pesel: '', employee_passport_number: '',
    job_title: '', job_description: '',
    work_location_city: '', contract_type: 'umowa_o_prace',
    work_hours: '1/1', salary_gross: '',
    period_from: '', period_to: '',
    destination_country: '', destination_address: '', delegation_purpose: '',
  });
  const [error, setError] = useState('');
  const userRole = user?.role || 'client';

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const res = await api.get('/work-permits/');
      setApps(Array.isArray(res.data) ? res.data : []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleSubmitForm = async () => {
    setError('');
    try {
      const body = { ...form };
      if (body.salary_gross) body.salary_gross = parseFloat(body.salary_gross);
      Object.keys(body).forEach(k => { if (body[k] === '') delete body[k]; });
      const res = await api.post('/work-permits/', body);
      setShowForm(false);
      load();
    } catch (e) {
      setError(e.response?.data?.detail || 'Ошибка');
    }
  };

  const handleAction = async (id, action, body = {}) => {
    try {
      const res = await api.post(`/work-permits/${id}/${action}`, body);
      load();
      if (selected?.id === id) {
        const det = await api.get(`/work-permits/${id}`);
        setSelected(det.data);
      }
    } catch (e) {
      alert(e.response?.data?.detail || 'Ошибка');
    }
  };

  const isA1 = form.document_type === 'zus_a1';
  const isZUS = form.document_type.startsWith('zus_');
  const isWork = ['oswiadczenie', 'powiadomienie_ua', 'zezwolenie_a'].includes(form.document_type);

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto' }}>
      <BackButton />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontSize: 24, margin: 0 }}>📋 Разрешения на работу</h1>
        <button onClick={() => setShowForm(true)}
          style={{ padding: '10px 20px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
          + Новая заявка
        </button>
      </div>

      {/* List */}
      {loading ? <p>{t('common.loading')}</p> : apps.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, background: '#1a1a2e', borderRadius: 12 }}>
          <p style={{ fontSize: 48 }}>📋</p>
          <p style={{ color: '#aaa' }}>Нет заявок. Создайте первую!</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {apps.map(a => {
            const st = STATUS_LABELS[a.status] || STATUS_LABELS.draft;
            const dt = DOC_TYPES.find(d => d.value === a.document_type);
            return (
              <div key={a.id} onClick={() => setSelected(a)}
                style={{ padding: 14, background: selected?.id === a.id ? '#1e293b' : '#111827',
                  borderRadius: 10, cursor: 'pointer', border: `1px solid ${selected?.id === a.id ? '#3b82f6' : '#333'}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <span style={{ fontSize: 14 }}>{dt?.label || a.document_type}</span>
                    <br />
                    <strong>{a.employee_first_name} {a.employee_last_name}</strong>
                    {a.job_title && <span style={{ color: '#888', marginLeft: 8 }}>— {a.job_title}</span>}
                  </div>
                  <span style={{ color: st.color, fontWeight: 'bold', fontSize: 13 }}>
                    {st.icon} {st.label}
                  </span>
                </div>
                {a.period_from && (
                  <div style={{ color: '#888', fontSize: 12, marginTop: 4 }}>
                    📅 {a.period_from} → {a.period_to}
                    {a.salary_gross && <span style={{ marginLeft: 12 }}>💰 {a.salary_gross} PLN</span>}
                  </div>
                )}

                {/* Admin actions */}
                {userRole === 'superadmin' && a.status === 'submitted' && (
                  <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
                    <button onClick={(e) => { e.stopPropagation(); handleAction(a.id, 'approve'); }}
                      style={{ padding: '6px 16px', background: '#10b981', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                      ✅ Утвердить
                    </button>
                    <button onClick={(e) => {
                      e.stopPropagation();
                      const reason = prompt('Причина отклонения:');
                      if (reason) handleAction(a.id, 'reject', { reason });
                    }}
                      style={{ padding: '6px 16px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                      ❌ Отклонить
                    </button>
                  </div>
                )}
                {userRole === 'superadmin' && a.status === 'approved' && (
                  <div style={{ marginTop: 8 }}>
                    <button onClick={(e) => { e.stopPropagation(); handleAction(a.id, 'file'); }}
                      style={{ padding: '6px 16px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                      🚀 Подать в гос.орган
                    </button>
                  </div>
                )}
                {a.status === 'draft' && (
                  <div style={{ marginTop: 8 }}>
                    <button onClick={(e) => { e.stopPropagation(); handleAction(a.id, 'submit'); }}
                      style={{ padding: '6px 16px', background: '#f59e0b', color: '#000', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                      📤 Отправить на рассмотрение
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* New Application Form Modal */}
      {showForm && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)',
          display: 'flex', justifyContent: 'center', alignItems: 'flex-start', paddingTop: 40, zIndex: 1000, overflowY: 'auto' }}>
          <div style={{ background: '#1a1a2e', borderRadius: 16, padding: 24, width: '90%', maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 style={{ marginTop: 0 }}>📋 Новая заявка</h2>

            {error && <div style={{ background: '#ef444433', color: '#ef4444', padding: 10, borderRadius: 8, marginBottom: 12 }}>{error}</div>}

            {/* Document type */}
            <label style={lbl}>Тип документа</label>
            <select value={form.document_type} onChange={e => setForm({ ...form, document_type: e.target.value })} style={inp}>
              {DOC_TYPES.map(d => <option key={d.value} value={d.value}>{d.label} — {d.desc}</option>)}
            </select>

            <h3>👤 Данные работника</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div>
                <label style={lbl}>Имя *</label>
                <input style={inp} value={form.employee_first_name} onChange={e => setForm({ ...form, employee_first_name: e.target.value })} />
              </div>
              <div>
                <label style={lbl}>Фамилия *</label>
                <input style={inp} value={form.employee_last_name} onChange={e => setForm({ ...form, employee_last_name: e.target.value })} />
              </div>
              <div>
                <label style={lbl}>Гражданство</label>
                <input style={inp} value={form.employee_citizenship} onChange={e => setForm({ ...form, employee_citizenship: e.target.value })} placeholder="np. Україна, Białoruś" />
              </div>
              <div>
                <label style={lbl}>Дата рождения</label>
                <input type="date" style={inp} value={form.employee_date_of_birth} onChange={e => setForm({ ...form, employee_date_of_birth: e.target.value })} />
              </div>
              <div>
                <label style={lbl}>PESEL</label>
                <input style={inp} value={form.employee_pesel} onChange={e => setForm({ ...form, employee_pesel: e.target.value })} />
              </div>
              <div>
                <label style={lbl}>Номер паспорта *</label>
                <input style={inp} value={form.employee_passport_number} onChange={e => setForm({ ...form, employee_passport_number: e.target.value })} />
              </div>
            </div>

            {/* Work details */}
            {(isWork || isZUS) && (
              <>
                <h3>💼 Данные о работе</h3>
                <label style={lbl}>Должность (stanowisko)</label>
                <input style={inp} value={form.job_title} onChange={e => setForm({ ...form, job_title: e.target.value })} />

                <label style={lbl}>Описание работы</label>
                <textarea style={{ ...inp, height: 60 }} value={form.job_description} onChange={e => setForm({ ...form, job_description: e.target.value })} />

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <div>
                    <label style={lbl}>Город</label>
                    <input style={inp} value={form.work_location_city} onChange={e => setForm({ ...form, work_location_city: e.target.value })} />
                  </div>
                  <div>
                    <label style={lbl}>Тип договора</label>
                    <select style={inp} value={form.contract_type} onChange={e => setForm({ ...form, contract_type: e.target.value })}>
                      {CONTRACT_TYPES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={lbl}>Etat</label>
                    <input style={inp} value={form.work_hours} onChange={e => setForm({ ...form, work_hours: e.target.value })} placeholder="1/1" />
                  </div>
                  <div>
                    <label style={lbl}>Зарплата brutto (PLN)</label>
                    <input type="number" style={inp} value={form.salary_gross} onChange={e => setForm({ ...form, salary_gross: e.target.value })} placeholder="min 4666" />
                  </div>
                  <div>
                    <label style={lbl}>Период от</label>
                    <input type="date" style={inp} value={form.period_from} onChange={e => setForm({ ...form, period_from: e.target.value })} />
                  </div>
                  <div>
                    <label style={lbl}>Период до</label>
                    <input type="date" style={inp} value={form.period_to} onChange={e => setForm({ ...form, period_to: e.target.value })} />
                  </div>
                </div>
              </>
            )}

            {/* A1 delegation */}
            {isA1 && (
              <>
                <h3>✈️ Делегирование</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <div>
                    <label style={lbl}>Страна</label>
                    <input style={inp} value={form.destination_country} onChange={e => setForm({ ...form, destination_country: e.target.value })} placeholder="np. Niemcy" />
                  </div>
                  <div>
                    <label style={lbl}>{t('common.address')}</label>
                    <input style={inp} value={form.destination_address} onChange={e => setForm({ ...form, destination_address: e.target.value })} />
                  </div>
                </div>
                <label style={lbl}>Цель делегирования</label>
                <textarea style={{ ...inp, height: 60 }} value={form.delegation_purpose} onChange={e => setForm({ ...form, delegation_purpose: e.target.value })} />
              </>
            )}

            <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
              <button onClick={handleSubmitForm}
                style={{ flex: 1, padding: 12, background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
                💾 Сохранить
              </button>
              <button onClick={() => setShowForm(false)}
                style={{ flex: 1, padding: 12, background: '#333', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const lbl = { display: 'block', fontSize: 12, color: '#aaa', marginTop: 8, marginBottom: 2 };
const inp = { width: '100%', padding: 10, background: '#111827', color: '#fff', border: '1px solid #333', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
